import { type DatabaseGroup } from '@databases/grouping/database-group';

type TimelineEntryGroup = {
  group: DatabaseGroup;
  entryIds: string[];
};

export function getTimelineEntryGroups({
  entryIds,
  entriesByGroup,
  groups
}: {
  entryIds: readonly string[];
  entriesByGroup: Readonly<Record<string, ReadonlySet<string>>>;
  groups: readonly DatabaseGroup[];
}): TimelineEntryGroup[] {
  return groups.map((group) => {
    const groupEntryIds = entriesByGroup[group.key];

    return {
      group,
      entryIds: groupEntryIds
        ? entryIds.filter((entryId) => groupEntryIds.has(entryId))
        : []
    };
  });
}
